/* Goldelucks add-ons (every page).
   - GLA.row(): the "Add to their gift" quick-add row (product page, cart drawer)
   - GLA.deal(): the add-on deal text, used by the row, the extras step, the cart and the drawer
   - GLA.src(): hidden line properties that say which surface an item was added from (Insights)
   The deal itself is a Shopify automatic discount; this file only describes it. Its numbers and
   on/off switch are theme settings ("Gift add-ons"), passed in as GLV2.deal. */
(function () {
  var G = window.GLV2 || {};
  var DEAL = G.deal || { on: true, pct: 20, min: 3 };
  var TYPES = G.addonTypes || ['Balloons', 'Chocolate', 'Add Ons', 'Box Sleeve Add On', 'Alcohol Bottle'];
  var MO = 'Delivers to Melbourne Only';

  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (c) { return '$' + (Math.round(c) / 100).toFixed(2).replace(/\.00$/, ''); };
  var img = function (u, w) { return u ? String(u).replace(/^\/\//, 'https://') + (String(u).indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  var post = function (u, b) { return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(b) }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); }); };
  var getCart = function () { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); };

  // Storefront events for Insights (customer events / web pixels)
  // Shopify.analytics arrives a moment after the page: events sent before it are held (up to 15 s), not lost
  var pubQ = [], pubT = 0, pubN = 0;
  var pubReady = function () { return window.Shopify && Shopify.analytics && Shopify.analytics.publish; };
  function pubFlush() {
    if (!pubReady() && ++pubN < 60) return;
    clearInterval(pubT); pubT = 0;
    var q = pubQ; pubQ = [];
    pubReady() && q.forEach(function (x) { try { Shopify.analytics.publish(x[0], x[1]); } catch (e) {} });
  }
  function pub(name, data) {
    if (!pubReady()) {
      pubQ.length < 50 && pubQ.push([name, data]);
      pubT || (pubN = 0, pubT = setInterval(pubFlush, 250));
      return;
    }
    try { Shopify.analytics.publish(name, data); } catch (e) {}
  }
  // A click that loads another page: the page is gone before Shopify hands the event to the pixel, so it's
  // queued (sessionStorage) and sent on the next page, if that comes within 10 minutes (TRACKING-EVENTS.md).
  function pubNav(name, data) {
    try {
      var q = JSON.parse(sessionStorage.getItem('glQ') || '[]');
      q.push([name, data, Date.now()]);
      sessionStorage.setItem('glQ', JSON.stringify(q.slice(-20)));
    } catch (e) { pub(name, data); }
  }
  // Sent once Shopify's real publish is there (its first stand-in only buffers, and a page left before the real
  // one loads loses the buffer), for up to 15 s. A click stays queued until it has gone, so a page left early hands
  // it on to the next one. Only clicks from earlier pages: one made here waits for the page it opens.
  var pageAt = Date.now();
  (function flushNav(n) {
    var f = pubReady();
    if (!f || /replayQueue/.test(String(f))) { n < 60 && setTimeout(function () { flushNav(n + 1); }, 250); return; }
    try {
      var q = JSON.parse(sessionStorage.getItem('glQ') || '[]'), keep = [];
      q.forEach(function (x) {
        if (x[2] >= pageAt) return keep.push(x);
        if (Date.now() - x[2] < 6e5) try { Shopify.analytics.publish(x[0], x[1]); } catch (e) {}
      });
      keep.length ? sessionStorage.setItem('glQ', JSON.stringify(keep)) : sessionStorage.removeItem('glQ');
    } catch (e) {}
  })(0);
  // gl_addons_view: once per surface per page view (Insights contract), at most 20 ids
  var viewed = {};
  function viewOnce(surface, ids, listId) {
    if (viewed[surface]) return;
    viewed[surface] = 1;
    pub('gl_addons_view', { surface: surface, product_ids: ids.slice(0, 20), list_id: listId || null });
  }

  /* Order: pinned add-ons first (Theme settings > Gift add-ons > Pinned add-ons, in that order), then,
     with "Smart add-on order" on, the Insights app's order for these gifts, then the usual order.
     Insights: GET /apps/insights/addons?product=<handle>[&product=...] -> { list_id, handles, melb_only };
     used only if it answers within 800 ms with 3+ handles. Off: no request at all. */
  var PINS = G.addonPins || [], SMART = !!G.smartAddons, smartCache = {};
  // the visitor's bucket, shared with the recommendation row (0 = control: the theme's own order)
  function bucket() {
    var b = String(Math.floor(10 * Math.random()));
    try {
      var s = sessionStorage.getItem('glRecoB');
      /^\d$/.test(s || '') ? (b = s) : sessionStorage.setItem('glRecoB', b);
    } catch (e) {}
    return b;
  }
  // gifts: handles or {handle, id}. Returns {list, handles}: Insights' order, or the theme's own
  // ({handles: []}) with list "t.<first gift's product id>" (first by handle, as Insights does).
  function smart(gifts) {
    if (!SMART) return Promise.resolve(null);
    gifts = (gifts || []).map(function (x) { return typeof x === 'string' ? { handle: x } : x || {}; }).filter(function (x) { return x.handle; })
      .sort(function (a, b) { return a.handle < b.handle ? -1 : a.handle > b.handle ? 1 : 0; }).slice(0, 10);
    if (!gifts.length) return Promise.resolve(null);
    var theme = { list: 't.' + (gifts[0].id || ''), handles: [] }, b = bucket();
    if (b === '0') return Promise.resolve(theme);
    var key = gifts.map(function (x) { return x.handle; }).join(',') + '|' + b;
    return smartCache[key] || (smartCache[key] = new Promise(function (done) {
      var over = false, t = setTimeout(function () { over = true; done(theme); }, 800);
      fetch('/apps/insights/addons?' + gifts.map(function (x) { return 'product=' + encodeURIComponent(x.handle); }).join('&') + '&b=' + b, { credentials: 'same-origin' })
        .then(function (r) { return r.status === 200 ? r.json() : null; })
        .then(function (j) {
          if (over) return;
          clearTimeout(t);
          done(j && j.handles && j.handles.length && j.list_id ? { list: String(j.list_id), handles: j.handles } : theme);
        })
        .catch(function () { over || (clearTimeout(t), done(theme)); });
    }));
  }
  function order(list, res) {
    var pin = {}, rk = {};
    PINS.forEach(function (h, i) { pin[h] = i; });
    ((res && res.handles) || []).forEach(function (h, i) { rk[h] = i; });
    return list.map(function (p, i) { return { p: p, i: i }; }).sort(function (a, b) {
      var ha = a.p.handle, hb = b.p.handle,
        pa = ha in pin ? pin[ha] : 1e6, pb = hb in pin ? pin[hb] : 1e6,
        ra = ha in rk ? rk[ha] : 1e6, rb = hb in rk ? rk[hb] : 1e6;
      return pa - pb || ra - rb || a.i - b.i;
    }).map(function (x) { return x.p; });
  }
  // Line properties for an item added from one of our surfaces. "_" keys stay off the order page and emails.
  function src(surface, extra) {
    var p = { _gl_src: surface };
    for (var k in extra || {}) p[k] = extra[k];
    return p;
  }

  var isAddon = function (i) { return TYPES.indexOf(i.product_type) > -1; };
  var addonCount = function (cart) { return ((cart && cart.items) || []).reduce(function (n, i) { return n + (isAddon(i) ? i.quantity : 0); }, 0); };
  // What the deal took off the add-on lines (0 until Shopify applies the discount)
  var addonSaved = function (cart) { return ((cart && cart.items) || []).reduce(function (n, i) { return n + (isAddon(i) ? +i.line_level_total_discount || 0 : 0); }, 0); };

  // The deal line. Never claims a discount the cart doesn't show.
  function deal(cart, ctx) {
    var d = dealRaw(cart, ctx);
    d.html = d.html.replace(/add-ons?/g, function (m) { return '<span class="gla-nw">' + m + '</span>'; });
    return d;
  }
  // ctx 'pdp': a product page, where the add-ons in the cart may belong to other gifts, so "applied"
  // says how many add-ons in the cart it's for.
  function dealRaw(cart, ctx) {
    if (!DEAL.on) return { html: '', ok: false, n: 0 };
    var n = addonCount(cart), left = DEAL.min - n, off = DEAL.pct + '% off your add-ons', saved = addonSaved(cart);
    // Shopify's discount is cart-wide (any add-ons, any gift), so this counts every add-on in the cart.
    var inCart = n + ' add-on' + (n === 1 ? '' : 's') + ' in your cart';
    // two parts: on phones the pill puts each on its own line instead of wrapping mid-phrase
    var two = function (a, b) { return '<b class="gla-d1">' + a + '</b><span class="gla-sep"> · </span><span class="gla-d2">' + b + '</span>'; };
    if (left > 0) return { n: n, ok: false, html: n ? two(inCart, left + ' more for ' + off) : '<b>Add ' + DEAL.min + ' add-ons, get ' + off + '.</b>' };
    return saved > 0
      ? { n: n, ok: true, html: ctx === 'pdp' ? two(inCart, DEAL.pct + '% off applied') : '<b>' + off + ' applied</b>' }
      : { n: n, ok: false, html: two(inCart, 'no add-on discount yet') };
  }

  // Occasion -> add-ons that suit it. Chocolates, drinks and ribbon suit everything.
  var OCC = {
    birthday: /birthday|candle|sparkler|(sixteen|twenty-one|thirty|forty|fifty|one)-topper/,
    anniversary: /anniversary|love-you|heart/,
    valentine: /love-you|heart/,
    wedding: /engage|bride|mrs|mr-mrs/,
    baby: /baby|gender|girl-or-boy/,
    christmas: /christmas/,
    mother: /love-you|heart|thank/,
    father: /thank/,
    thank: /thank/,
    congrat: /congrat|good-luck/,
    retire: /retire|missed/,
    'get well': /get-well/
  };
  var THEMED = /birthday|candle|sparkler|topper|anniversary|love-you|heart|engage|bride|mrs|baby|gender|christmas|thank|congrat|good-luck|retire|missed|get-well/;
  var themed = function (p) { return /^(Balloons|Add Ons|Box Sleeve Add On)$/.test(p.type) && THEMED.test(p.handle); };

  // The add-ons: handles from the cart add-ons list (GLV2.addons), product data from the add-ons collection
  // (one request), filtered to the add-on product types and in stock.
  var CAT = null;
  function catalog() {
    if (CAT) return CAT;
    var hs = [];
    (G.addons || []).forEach(function (c) { (c.handles || []).forEach(function (h) { hs.indexOf(h) < 0 && hs.push(h); }); });
    var norm = function (p, js) {
      var vs = (p.variants || []).filter(function (v) { return v.available; });
      if (!vs.length) return null;
      var im = js ? p.featured_image : ((p.images || [])[0] || {}).src;
      return { id: p.id, handle: p.handle, title: p.title, type: js ? p.type : p.product_type, mo: (p.tags || []).indexOf(MO) > -1, v: vs[0].id, price: js ? vs[0].price : Math.round(parseFloat(vs[0].price) * 100), img: im };
    };
    CAT = fetch('/collections/add-ons/products.json?limit=250').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; })
      .then(function (j) {
        var m = {};
        (j.products || []).forEach(function (p) { m[p.handle] = p; });
        return Promise.all(hs.map(function (h) {
          if (m[h]) return norm(m[h]);
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { return p && norm(p, true); }).catch(function () { return null; });
        }));
      })
      .then(function (ps) { return ps.filter(function (p) { return p && TYPES.indexOf(p.type) > -1; }); });
    return CAT;
  }
  // Matching add-ons first, then the ones that suit anything, then (no occasion only) the rest.
  function rank(list, occ) {
    var re = OCC[occ];
    var a = [], b = [], c = [];
    list.forEach(function (p) { (re && themed(p) && re.test(p.handle) ? a : !themed(p) ? b : c).push(p); });
    return re ? a.concat(b) : b.concat(c);
  }

  /* Add-ons belong to one gift: each add carries _gl_for = that gift's product id, and every page
     (product page, extras step, drawer) starts with nothing ticked. Its "Added" counts are what was
     added there, not what's already in the cart for other gifts. */
  var HIDDEN = /HIDDEN|HIDEPRODUCT|Protection|Delivery Guarantee/i;
  // The gift add-ons go with on the cart, drawer and extras step: the most recently added gift
  function giftOf(cart) {
    var g = ((cart && cart.items) || []).filter(function (i) { return !isAddon(i) && !HIDDEN.test(i.product_type || '') && i.handle !== 'just-right-delivery' && i.price > 0; })[0];
    return g ? { id: g.product_id, title: g.product_title, handle: g.handle } : null;
  }
  /* "Hide add-on types for templates" (Theme settings > Gift add-ons): e.g. box sleeves don't fit
     butterfly explosion boxes. A type is hidden for a gift on a listed template; on the cart and in the
     drawer, only when no gift in the cart can take it. Templates come from the page (no requests). */
  var HIDE = {};
  String(G.addonHide || '').split(/\n/).forEach(function (l) {
    var m = l.split('=');
    m.length > 1 && m[0].trim() && (HIDE[m[0].trim()] = (HIDE[m[0].trim()] || []).concat(m.slice(1).join('=').split(',').map(function (x) { return x.trim(); }).filter(Boolean)));
  });
  // a cart gift's template: this product page's, else the cart page map, else the map printed on every page
  function tplOf(pid) {
    var t = G.tplAll || {}, c = G.tpl || {};
    if (G.p3 && +G.p3.id === +pid) return G.suffix || '';
    return pid in c ? c[pid] : pid in t ? t[pid] : null;
  }
  // types hidden for these templates: only types every one of them hides (unknown template: hides nothing)
  function hiddenFor(tpls) {
    if (!tpls.length) return [];
    return (HIDE[tpls[0]] || []).filter(function (ty) {
      return tpls.every(function (s) { return s != null && (HIDE[s] || []).indexOf(ty) > -1; });
    });
  }
  function giftItems(cart) {
    var seen = {};
    return ((cart && cart.items) || []).filter(function (i) { return !isAddon(i) && !HIDDEN.test(i.product_type || '') && i.handle !== 'just-right-delivery' && i.price > 0 && !seen[i.product_id] && (seen[i.product_id] = 1); });
  }
  // hidden types for a surface: "product" (this page), "gift" (the gift just added), "cart" (every gift)
  function hiddenTypes(scope, cart) {
    if (scope === 'product') return hiddenFor([G.suffix || '']);
    var g = giftItems(cart);
    if (!g.length) return [];
    return hiddenFor((scope === 'gift' ? g.slice(0, 1) : g).map(function (i) { return tplOf(i.product_id); }));
  }
  // a line in the cart that no gift there can take: the note to show on it
  function misfit(item, cart) {
    if (!isAddon(item) || hiddenTypes('cart', cart).indexOf(item.product_type) < 0) return '';
    return /sleeve/i.test(item.product_type) ? "Box sleeves don't fit butterfly explosion boxes" : "This add-on doesn't go with the gifts in your cart";
  }
  // the cart's gifts as {handle, id} (for the smart order)
  function giftRefs(cart) {
    return giftItems(cart).map(function (i) { return { handle: i.handle, id: i.product_id }; });
  }
  // every main gift in the cart (for the smart order on cart surfaces)
  function gifts(cart) {
    var seen = {};
    return ((cart && cart.items) || []).filter(function (i) { return !isAddon(i) && !HIDDEN.test(i.product_type || '') && i.handle !== 'just-right-delivery' && i.price > 0 && !seen[i.handle] && (seen[i.handle] = 1); }).map(function (i) { return i.handle; });
  }
  // "For: Cake Explosion Box" under an add-on line (its gift's title, from the cart)
  function forTitle(item, cart) {
    var f = +((item.properties || {})._gl_for || 0);
    var g = f && ((cart && cart.items) || []).filter(function (i) { return i.product_id === f && !isAddon(i); })[0];
    return g ? g.product_title : '';
  }
  function addFor(o) {
    var props = src(o.surface, o.forId ? { _gl_for: String(o.forId) } : {});
    return post('/cart/add.js', { items: [{ id: o.variantId, quantity: 1, properties: props }] }).then(function (r) {
      pub('gl_addon_add', { surface: o.surface, product_id: o.productId, variant_id: o.variantId, price: o.price / 100, for_product_id: o.forId || null, list_id: o.listId || null });
      return r;
    });
  }
  // Undo one: the line for this add-on and this gift goes down by 1
  function undoFor(o) {
    return getCart().then(function (c) {
      var l = c.items.filter(function (i) { return i.handle === o.handle && String((i.properties || {})._gl_for || '') === String(o.forId || '') && (i.properties || {})._gl_src; })[0]
        || c.items.filter(function (i) { return i.handle === o.handle && String((i.properties || {})._gl_for || '') === String(o.forId || ''); })[0];
      return l ? post('/cart/change.js', { id: l.key, quantity: l.quantity - 1 }) : null;
    });
  }
  // Tile status under the price: "Added ✓ · Undo" / "2 added · Undo"
  function status(n, title) {
    return n ? '<span>' + (n === 1 ? 'Added &#10003;' : n + ' added') + '</span> · <button type="button" class="gla-undo" aria-label="Remove one ' + esc(title) + '">Undo</button>' : '';
  }

  /* Delivery zone, from the place the delivery bar, the search card and the cart widget save
     (sessionStorage "pd:draft"): "national" (Rest of Australia), "melbourne", "pickup" or "" (not chosen yet).
     No requests. Melbourne-only add-ons are hidden for Rest of Australia; with no place yet they show
     with a "Melbourne only" pill, after the Australia-wide ones. */
  function zone() {
    try {
      var d = JSON.parse(sessionStorage.getItem('pd:draft') || 'null');
      if (!d) return '';
      if (d.method === 'pickup') return 'pickup';
      return d.zone === 'national' ? 'national' : d.zone === 'melbourne' ? 'melbourne' : '';
    } catch (e) { return ''; }
  }
  function postcode() {
    try { return (JSON.parse(sessionStorage.getItem('pd:draft') || 'null') || {}).postcode || ''; } catch (e) { return ''; }
  }
  // by zone: drop Melbourne-only for Rest of Australia; unknown: Australia-wide first (order kept)
  function byZone(list, z) {
    if (z === 'national') return list.filter(function (p) { return !p.mo; });
    if (z) return list;
    return list.filter(function (p) { return !p.mo; }).concat(list.filter(function (p) { return p.mo; }));
  }
  var MO_PILL = '<span class="gla-mo">Melbourne only</span>';
  /* No place yet (Phillip, 28 Oct): no "Melbourne only" pill on every tile.
     - The gift is Melbourne-only: it's going to Melbourne anyway, so no pills and no note.
     - Otherwise: a group tab (GLV2.addons) that's all Melbourne-only says "Melbourne only" instead of its
       count (gl-v3-cart-shelf.js), and a pill goes only on the Melbourne-only items of a mixed group.
     scope: "cart" (every gift in the cart), else this product page's gift (or the cart's first gift). */
  var moP = {};
  function giftMO(scope, cart) {
    if (scope !== 'cart' && G.product && G.p3) return Promise.resolve(!!G.product.melbourneOnly);
    var gs = giftItems(cart);
    scope === 'cart' || (gs = gs.slice(0, 1));
    return Promise.all(gs.map(function (i) {
      return moP[i.handle] || (moP[i.handle] = fetch('/products/' + i.handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return !!p && (p.tags || []).indexOf(MO) > -1; }).catch(function () { return false; }));
    })).then(function (a) { return a.some(Boolean); });
  }
  // the add-on groups (in stock, add-on types, not hidden): names all Melbourne-only, names mixed, handles to pill
  function moInfo(hid) {
    return catalog().then(function (all) {
      var by = {}, r = { full: [], mixed: [], pill: {} };
      all.forEach(function (p) { by[p.handle] = p; });
      (G.addons || []).forEach(function (g) {
        var ps = (g.handles || []).map(function (h) { return by[h]; }).filter(function (p) { return p && (hid || []).indexOf(p.type) < 0; }),
          mo = ps.filter(function (p) { return p.mo; });
        if (!mo.length) return;
        if (mo.length === ps.length) return r.full.push(g.name);
        r.mixed.push(g.name);
        mo.forEach(function (p) { r.pill[p.handle] = 1; });
      });
      return r;
    });
  }
  // re-check the saved place now and then (cheap: sessionStorage only), and tell rows when it changes
  var lastZone = zone();
  setInterval(function () {
    var z = zone();
    z !== lastZone && ((lastZone = z), document.dispatchEvent(new CustomEvent('gla:zone', { detail: { zone: z } })));
  }, 1000);

  /* Gift Upgrade guard (order #136397: 1 box, "Gift Upgrade" confetti line at 2, so $10 charged twice).
     Each upgrade line (the hidden Gift Upgrade / butterfly upgrade products, and the confetti card) must
     equal the quantity of the boxes that point at it with "_extra_variant_id:"; one line per upgrade
     variant, orphans removed. One update.js call by line key (no line numbers, so a stale index can't hit
     the wrong line). Runs on cart page load (gl-v3-cart.js), on drawer open (gl-cro.js) and before
     checkout (below). Returns the cart as it is after the fix. */
  var UPG = /^(on-variant-hidden-product|gift-upgrade-butterflies)$/, CONF_V = 40138856890430;
  var isUpg = function (i) { return UPG.test(i.handle || '') || i.variant_id === CONF_V; };
  var upOf = function (i) { var p = i.properties || {}; for (var k in p) if (/_extra_variant_id/.test(k) && p[k]) return +p[k] || 0; return 0; };
  function upgradeFixes(cart) {
    var want = {}, seen = {}, u = {}, n = 0, its = (cart && cart.items) || [];
    its.forEach(function (i) { var v = !isUpg(i) && upOf(i); v && (want[v] = (want[v] || 0) + i.quantity); });
    its.forEach(function (i) {
      if (!isUpg(i)) return;
      var q = seen[i.variant_id] ? 0 : want[i.variant_id] || 0;
      seen[i.variant_id] = 1;
      q !== i.quantity && ((u[i.key] = q), n++);
    });
    return n ? u : null;
  }
  function syncUpgrades(cart) {
    return (cart && cart.items ? Promise.resolve(cart) : getCart()).then(function (c) {
      var u = upgradeFixes(c);
      if (!u) return c;
      pub('gl_upgrade_fix', { lines: Object.keys(u).length });
      return post('/cart/update.js', { updates: u }).then(function (r) { return r && r.items ? r : getCart(); });
    });
  }
  // After any cart write (this theme, the delivery widget, Just Right, old scripts; fetch or XHR): check again once
  // the cart has been quiet for 1.2 s, so a run of writes (the delivery widget updates line by line) is never
  // cut into. At most 3 fixes in 10 s, so a fix that doesn't stick can't loop.
  var CW = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/, swT = 0, swN = [];
  function afterWrite() {
    clearTimeout(swT);
    swT = setTimeout(function () {
      var now = Date.now();
      swN = swN.filter(function (t) { return now - t < 1e4; });
      getCart().then(function (c) { dealStep(c); swN.length < 3 && upgradeFixes(c) && (swN.push(now), syncUpgrades(c).then(function (r) { document.dispatchEvent(new CustomEvent('gla:upgrades', { detail: { cart: r } })); })); }).catch(function () {});
    }, 1200);
  }
  try {
    var oF = window.fetch;
    oF && (window.fetch = function (u) {
      var r = oF.apply(this, arguments);
      try { CW.test(String((u && u.url) || u)) && r.then(afterWrite, afterWrite); } catch (e) {}
      return r;
    });
    var oO = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { CW.test(String(u)) && this.addEventListener('loadend', afterWrite); } catch (e) {}
      return oO.apply(this, arguments);
    };
  } catch (e) {}
  // Before checkout: start the fix as the finger goes down on a checkout button (pointerdown/touchstart
  // come before the click). The click itself is never held or replayed: Just Right's Checkout+ ignored
  // the replayed click (28 Oct). The after-write check above covers the rest.
  var CK = 'button[name="checkout"], input[name="checkout"], .jr-primary, .jr-secondary, a[href^="/checkout"], form[action="/checkout"] [type="submit"]';
  var ckAt = 0;
  var ckEarly = function (e) {
    var b = e.target && e.target.closest && e.target.closest(CK);
    if (!b || Date.now() - ckAt < 1500) return;
    ckAt = Date.now();
    syncUpgrades().catch(function () {});
  };
  document.addEventListener('pointerdown', ckEarly, true);
  document.addEventListener('touchstart', ckEarly, { capture: true, passive: true });

  var ICON_ADD = '+';
  // The header badge: items the shopper sees, as the drawer and cart page list them. Not counted: the
  // confetti / butterfly upgrades, the printed card, the butterfly photo fee, order protection and
  // hidden lines. Same rule as snippets/menu-cart.liquid.
  var shown = function (i) {
    var t = i.product_type || '';
    return !(/HIDDEN|Protection|Delivery Guarantee/i.test(t) || (/HIDEPRODUCT/i.test(t) && (i.properties || {})._common_random_string) ||
      /^(just-right-delivery|on-variant-hidden-product|gift-upgrade-butterflies)$/.test(i.handle) || i.variant_id === 40138856890430 || i.variant_id === 39603053559870);
  };
  var count = function (cart) { return ((cart && cart.items) || []).reduce(function (t, i) { return t + (shown(i) ? i.quantity : 0); }, 0); };
  var badge = function (cart) {
    var n = count(cart);
    [].forEach.call(document.querySelectorAll('.tt-badge-cart'), function (b) { b.textContent = n; b.classList.toggle('hide', !n); });
  };

  /* The quick-add row.
     opts: surface ("pdp-addons" | "drawer-addons"), forId (gift product id, or function(cart)), occ (occasion key),
     title, limit, onChange(cart).
     Returns { el, sync(cart) } so a host that redraws can keep the same row (and its scroll). */
  function row(opts) {
    var el = document.createElement('section');
    el.className = 'gla' + (opts.compact ? ' gla--compact' : '');
    el.setAttribute('aria-label', opts.title || 'Add to their gift');
    el.innerHTML = '<div class="gla-h"><h2>' + esc(opts.title || 'Add to their gift') + '</h2><p class="gla-deal" aria-live="polite"></p></div><div class="gla-row"></div>';
    var rowEl = el.querySelector('.gla-row'), dealEl = el.querySelector('.gla-deal'), cart = null, items = [];
    // no place yet: is the gift Melbourne-only, and which items get a pill (redraws once known)
    var moS = {}, moState = function (hid) {
      var k = hid.join(',') + '|' + giftItems(cart).map(function (i) { return i.handle; }).join(',');
      if (moS.k !== k) {
        moS = { k: k };
        var me = moS;
        Promise.all([giftMO(opts.hideScope === 'cart' ? 'cart' : 'product', cart), moInfo(hid)]).then(function (x) {
          me.r = x[0] ? { full: [], mixed: [], pill: {} } : x[1];
          moS === me && render && render();
        });
      }
      return moS;
    }, render = null;
    var added = {}, res = null, fid = function () { return typeof opts.forId === 'function' ? opts.forId(cart) : opts.forId; };
    var paint = function () {
      var d = deal(cart, opts.surface === 'pdp-addons' ? 'pdp' : '');
      dealEl.innerHTML = d.html;
      dealEl.hidden = !d.html;
      dealEl.classList.toggle('ok', d.ok);
      [].forEach.call(rowEl.querySelectorAll('.gla-t'), function (t) {
        var b = t.querySelector('.gla-b'), h = b.getAttribute('data-h'), n = added[h] || 0, tt = b.getAttribute('data-t');
        t.classList.toggle('in', n > 0);
        t.querySelector('.gla-st').innerHTML = status(n, tt);
        if (b.__busy) return;
        b.innerHTML = ICON_ADD;
        b.setAttribute('aria-label', (n ? 'Add another ' : 'Add ') + tt);
      });
    };
    var sync = function (c) { cart = c; paint(); };
    var changed = function (c) { sync(c); badge(c); opts.onChange && opts.onChange(c); document.dispatchEvent(new CustomEvent('gla:change', { detail: { cart: c, surface: opts.surface } })); };
    var busy = false;
    var run = function (b, go, after) {
      if (busy) return;
      busy = true; b.__busy = true; b.disabled = true;
      var was = b.innerHTML; b.innerHTML = '<span class="gla-spin" aria-hidden="true"></span>';
      go().then(function () { after(); return getCart(); })
        .then(function (c) { busy = false; b.__busy = false; b.disabled = false; b.innerHTML = was; changed(c); })
        .catch(function () { busy = false; b.__busy = false; b.disabled = false; b.innerHTML = was; getCart().then(changed).catch(paint); });
    };
    var tap = function (b) {
      var h = b.getAttribute('data-h'), p = items.filter(function (x) { return x.handle === h; })[0];
      run(b, function () { return addFor({ surface: opts.surface, variantId: p.v, productId: p.id, price: p.price, forId: fid(), listId: res && res.list }); }, function () { added[h] = (added[h] || 0) + 1; });
    };
    var undo = function (u) {
      var t = u.closest('.gla-t'), b = t.querySelector('.gla-b'), h = b.getAttribute('data-h');
      run(u, function () { return undoFor({ handle: h, forId: fid() }); }, function () { added[h] = Math.max(0, (added[h] || 0) - 1); });
    };
    Promise.all([catalog(), cart ? Promise.resolve(cart) : (opts.cart ? Promise.resolve(opts.cart) : getCart())]).then(function (r) {
      cart = cart || r[1];
      var all = rank(r[0], opts.occ), settled = !SMART;
      render = function () {
        var place = window.GL3S && GL3S.place && GL3S.place(),
          z = zone() || (place ? (place.out ? 'national' : 'melbourne') : '');
        var hid = hiddenTypes(opts.hideScope || 'product', cart);
        items = byZone(order(all.filter(function (p) { return hid.indexOf(p.type) < 0; }), res), z).slice(0, opts.limit || 12);
        el.hidden = !items.length;
        var mo = z ? null : moState(hid), pill = function (p) { return p.mo && mo && mo.r && mo.r.pill[p.handle] ? MO_PILL : ''; };
        rowEl.innerHTML = items.map(function (p) {
          var t = p.title.replace(/ Balloon$/, ' balloon');
          return '<div class="gla-t"><div class="gla-im">' + (p.img ? '<img loading="lazy" src="' + esc(img(p.img, 240)) + '" alt="">' : '') +
            '<button type="button" class="gla-b" data-h="' + esc(p.handle) + '" data-t="' + esc(t) + '" aria-label="Add ' + esc(t) + '">' + ICON_ADD + '</button></div>' +
            '<span class="gla-n">' + esc(t) + '</span>' + pill(p) + '<span class="gla-p">' + money(p.price) + '</span><span class="gla-st" aria-live="polite"></span></div>';
        }).join('');
        paint();
        rowEl.dispatchEvent(new Event('scroll')); // lets a scroller wrapper (gl-v3-low.js) update its arrows
      };
      render();
      // smart order (setting on): drawn first in the usual order, swapped if Insights answers in time
      SMART && smart(typeof opts.smartFor === 'function' ? opts.smartFor(cart) : opts.smartFor).then(function (x) {
        x && ((res = x), render());
        settled = true;
        seenRow && view();
      });
      // the place changed (delivery bar "Change", search card): show the right add-ons, no reload
      document.addEventListener('gla:zone', render);
      rowEl.addEventListener('click', function (e) { var u = e.target.closest('.gla-undo'), b = e.target.closest('.gla-b'); u ? undo(u) : b && tap(b); });
      // one view event per row, once it's on screen
      var seenRow = false, view = function () { seenRow = true; settled && viewOnce(opts.surface, items.map(function (p) { return p.id; }), res && res.list); };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.some(function (x) { return x.isIntersecting; }) && (view(), io.disconnect()); }, { threshold: 0.4 });
        io.observe(rowEl);
      } else view();
    });
    return { el: el, sync: sync };
  }

  /* Tracking (TRACKING-EVENTS.md, 29 Oct): one customer event, gl_ui {feature, action, item?, position?}, sent with
     Shopify.analytics.publish (pub). Items are product ids or fixed slugs from the theme (option, tab, section and
     filter names), never anything a shopper typed. A view is sent once per page for each feature and item. This
     watches the page (clicks, swipes, what comes on screen), so each feature's own code stays as it is. */
  var slug = function (s) { return String(s || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40); };
  var uiOnce = {};
  function ui(feature, action, item, position, nav) {
    var d = { feature: feature, action: action };
    item != null && item !== '' && (d.item = typeof item === 'number' ? item : String(item).slice(0, 40));
    position && (d.position = +position);
    if (action === 'view' || feature === 'gallery') {
      var k = feature + '|' + action + '|' + (d.item || '');
      if (uiOnce[k]) return;
      uiOnce[k] = 1;
    }
    (nav ? pubNav : pub)('gl_ui', d);
    // the last 100, for checking on a phone (window.GLA_UI_LOG in the console)
    var lg = window.GLA_UI_LOG || (window.GLA_UI_LOG = []);
    lg.length < 100 && lg.push(d);
  }
  // a view once it's on screen: 40% of it, or (a tall section) 40% of the screen. Checked by scan() below.
  var pend = [];
  function seen(el, feature, item) {
    if (!el || el.__glui) return;
    el.__glui = 1;
    pend.push([el, feature, item]);
  }
  function views() {
    var h = innerHeight;
    pend = pend.filter(function (x) {
      if (!x[0].isConnected) return false;
      if (!x[0].offsetParent && getComputedStyle(x[0]).position !== 'fixed') return true;
      var r = x[0].getBoundingClientRect(), v = Math.min(r.bottom, h) - Math.max(r.top, 0);
      if (r.height > 0 && v >= 0.4 * Math.min(r.height, h)) { ui(x[1], 'view', x[2]); return false; }
      return true;
    });
  }
  // shownEl, not "shown": a second "var shown" replaced the cart-line one above (hoisting), so GLA.count threw on any
  // cart with items and the drawer fell back to /cart
  var shownEl = function (el) { if (!el || (!el.offsetParent && getComputedStyle(el).position !== 'fixed')) return false; var r = el.getBoundingClientRect(); return r.height > 0 && r.top < innerHeight && r.bottom > 0 && getComputedStyle(el).visibility !== 'hidden'; };
  var HOME = location.pathname === '/';
  // a home section's name: its first heading, else its place on the page
  function secOf(el) {
    var s = el && el.closest('.shopify-section');
    if (!s || /header|footer|announcement|modal|promo-fixed|product-message|show-helper/i.test(s.id)) return null;
    var all = [].filter.call(document.querySelectorAll('.shopify-section'), function (x) { return !/header|footer|announcement|modal|promo-fixed|product-message|show-helper/i.test(x.id); });
    var h = s.querySelector('h1,h2,h3'), named = /1530224149715$/.test(s.id) ? 'corporate-hero' : /d0ed07c9-352c-4f91-a961-294f72d07060$/.test(s.id) ? 'category-tiles' : '';
    // the two home sections with no heading get names (Insights); the rest use their heading
    return { el: s, name: named || slug(h && h.textContent) || 'section-' + (all.indexOf(s) + 1) };
  }
  // a home tile whose picture isn't a link (e.g. "Personalised treats": only its button is): the tile's one link
  function tileLink(t) {
    for (var e = t, i = 0; e && i < 6 && !(e.classList && e.classList.contains('shopify-section')); e = e.parentElement, i++) {
      var hs = [], as = e.querySelectorAll ? e.querySelectorAll('a[href]') : [];
      [].forEach.call(as, function (a) { hs.indexOf(a.getAttribute('href')) < 0 && hs.push(a.getAttribute('href')); });
      if (hs.length === 1) return as[0];
      if (hs.length > 1) return null;
    }
    return null;
  }
  var MOTXT = /^\s*Melbourne only\s*$/;
  function scan() {
    seen(document.querySelector('.g3-gal'), 'gallery');
    seen(document.querySelector('.g3-rvc'), 'reviews');
    [].forEach.call(document.querySelectorAll('.gla-deal:not([hidden]), .g3c-bb:not([hidden])'), function (x) { seen(x, 'deal_progress'); });
    [].forEach.call(document.querySelectorAll('.g3c-cat:not([hidden])'), function (x) { var s = x.querySelector('span'); s && MOTXT.test(s.textContent) && seen(x, 'melb_only', 'tab'); });
    [].forEach.call(document.querySelectorAll('.gla-mo'), function (x) { seen(x, 'melb_only', 'pill'); });
    HOME && [].forEach.call(document.querySelectorAll('.shopify-section'), function (s) { var q = s.querySelector('a[href]') && secOf(s); q && seen(s, 'home_section', q.name); });
    var st = document.querySelector('.g3-sticky');
    st && shownEl(st) && ui('sticky_atc', 'view');
    views();
  }
  // at most every 300 ms while scrolling or while the page changes
  var scT = 0, scLater = function () { scT || (scT = setTimeout(function () { scT = 0; scan(); }, 300)); };
  'MutationObserver' in window && document.addEventListener('DOMContentLoaded', function () { scan(); new MutationObserver(scLater).observe(document.body, { childList: true, subtree: true }); });
  addEventListener('scroll', scLater, { passive: true });
  var pid = function () { var p = (window.GLV2 || {}).p3; return p && p.id ? +p.id : null; };
  var lastF = { k: '', t: 0 };
  document.addEventListener('click', function (e) {
    var t = e.target, c = function (s) { return t.closest && t.closest(s); }, x;
    if ((x = c('.g3-xo'))) return ui('gift_upgrade', 'click', slug((x.querySelector('b') || x).textContent) || 'option');
    if (c('.g3-gal .g3-arw') || c('.g3-gal .g3-all')) return ui('gallery', 'open', 'photo');
    if ((x = c('.g3-rev a[href]'))) return /\/pages\/reviews/.test(x.getAttribute('href')) && ui('reviews', 'click', 'all');
    if (c('.g3-sticky .g3-atc')) return ui('sticky_atc', 'click', pid());
    if ((x = c('#glh .glh-fab'))) return x.getAttribute('aria-expanded') !== 'true' && ui('help', 'open', 'fab');
    if ((x = c('#glh a, #glh button'))) return /text us/i.test(x.textContent) && ui('coax', 'open', 'help-menu');
    if (c('#coax-widget-bubble')) return ui('coax', 'open', 'launcher');
    if ((x = c('.g3c-cat'))) { var s = x.querySelector('span'); return s && MOTXT.test(s.textContent) && ui('melb_only', 'click', 'tab'); }
    if ((x = c('.g3-tabs__bar button'))) return ui('pdp_tabs', 'click', slug(x.textContent));
    if (c('.jr-primary')) return ui('checkout_choice', 'click', 'protected');
    if (c('.jr-secondary')) return ui('checkout_choice', 'click', 'plain');
    if ((x = c('.gf-option-block li, .gf-option-block label, .gf-option-block a, .gf-option-block .gf-Checkbox'))) {
      var b = x.closest('.gf-option-block'), k = slug(((b.querySelector('.gf-block-title') || {}).textContent || '') + ' ' + ((x.querySelector('.gf-label') || x).textContent || ''));
      if (k && !(lastF.k === k && Date.now() - lastF.t < 400)) { lastF = { k: k, t: Date.now() }; ui('collection_filter', 'click', k); }
      return;
    }
    if (HOME && (x = c('a[href]') || tileLink(t))) {
      var q = secOf(x);
      if (!q) return;
      var hs = [];
      [].forEach.call(q.el.querySelectorAll('a[href]'), function (a) { var h = a.getAttribute('href'); hs.indexOf(h) < 0 && hs.push(h); });
      ui('home_section', 'click', q.name, hs.indexOf(x.getAttribute('href')) + 1, /^(#|javascript:)/.test(x.getAttribute('href')) ? 0 : 1);
    }
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.closest && t.closest('.sort-by, .sortby-select, .sort-position')) ui('collection_filter', 'click', 'sort-' + slug(t.value));
    else if (t.closest && t.closest('.gf-range-inputs')) ui('collection_filter', 'click', 'price');
  }, true);
  // swipes: the gallery (first one opens "photo"), the reviews row (next / prev). Gallery swipes and video plays
  // count only just after the shopper touched the gallery (its video can start by itself).
  var galAt = 0, rvT = 0;
  ['pointerdown', 'touchstart'].forEach(function (n) {
    document.addEventListener(n, function (e) { e.target && e.target.closest && e.target.closest('.g3-gal') && (galAt = Date.now()); }, { capture: true, passive: true });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.g3-gal')) return Date.now() - galAt < 2000 && ui('gallery', 'open', 'photo');
    if (t.classList && t.classList.contains('g3-rvc__row')) {
      clearTimeout(rvT);
      rvT = setTimeout(function () { var d = t.scrollLeft - (t.__glx || 0); t.__glx = t.scrollLeft; Math.abs(d) > 30 && ui('reviews', 'click', d > 0 ? 'next' : 'prev'); }, 250);
    }
  }, true);
  document.addEventListener('play', function (e) { e.target && e.target.closest && e.target.closest('.g3-gal') && Date.now() - galAt < 2000 && ui('gallery', 'open', 'video'); }, true);
  // the add-on deal: each step as add-ons go in (checked after cart writes, below)
  var dealN = null;
  function dealStep(c) {
    if (!DEAL.on || !document.querySelector('.gla-deal, .g3c-bb')) return;
    var n = addonCount(c);
    if (dealN != null && n > dealN && n > 0) ui('deal_progress', 'step', n >= DEAL.min ? 'reached' : n + '-of-' + DEAL.min);
    dealN = n;
  }
  document.addEventListener('DOMContentLoaded', function () { document.querySelector('.gla-deal, .g3c-bb, .g3-tabs, .main-cart-page') && getCart().then(function (c) { dealN == null && (dealN = addonCount(c)); }).catch(function () {}); });

  window.GLA = { row: row, count: count, badge: badge, giftRefs: giftRefs, hiddenTypes: hiddenTypes, misfit: misfit, smart: smart, order: order, gifts: gifts, zone: zone, postcode: postcode, byZone: byZone, moPill: MO_PILL, giftMO: giftMO, moInfo: moInfo, syncUpgrades: syncUpgrades, upgradeFixes: upgradeFixes, deal: deal, src: src, pub: pub, giftOf: giftOf, forTitle: forTitle, addFor: addFor, undoFor: undoFor, status: status, viewOnce: viewOnce, isAddon: isAddon, saved: addonSaved, money: money, config: DEAL, ui: ui, pubNav: pubNav, uiPending: function () { return pend.map(function (x) { return x[1] + ':' + (x[2] || ''); }); } };
})();
